import { FileExcelOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  CommandBar,
  Link,
  Pivot,
  PivotItem,
  PivotLinkSize,
  ProgressIndicator,
  SearchBox,
} from "@fluentui/react";
import {
  DatePicker,
  Form,
  Tooltip,
  Layout,
  Input,
  notification,
  message,
  Badge,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import React, { createContext, useContext, useRef } from "react";
import moment from "moment";
import { X } from "react-feather";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";

import { ENV } from "../../Infrastructure/EnvironmentConfig";

import { ErrorLogs } from "./ErrorLogs";
import { AgGridReact } from "ag-grid-react";
import formatNumber from "accounting-js/lib/formatNumber";
import { getPickerDate, toAntPickerDate } from "../../Utility/modules/datePicker";

const { Content, Sider } = Layout;
const _ = require("underscore");
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const MonthlyProductionUpload = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const prodImportGrid = useRef(null);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(monthlyPerformanceStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description: "string production input deck sheet name is required",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/MonthlyProduction/ImportNaocMonthlyProductionExcel?data=${monthlyPerformanceStore.sheetName}`,

    onChange(info) {
      try {
        const { status } = info.file;

        if (status === "done") {
          const { productionData, errors } = info.file.response;

          if (productionData.length) {
            monthlyPerformanceStore.monthlyProductions.clear();
            monthlyPerformanceStore.monthlyProductions = [...productionData];
          }
          console.log(errors);
          if (errors.length) {
            monthlyPerformanceStore.uploadErrors = errors;

            monthlyPerformanceStore.selTab = "2";
          } else {
            monthlyPerformanceStore.uploadErrors = [];
            monthlyPerformanceStore.selTab = "1";
          }
        } else if (status === "error") {
          monthlyPerformanceStore.showUploadErrorMessage = true;
          message.error(`${info.file.name} file preview failed.`);
          notification.error({
            message: "SPARS Feedback",
            description: `${info.file.response}`,
          });
        }
      } catch (error) {
        message.error(`${info.file.name} file preview failed.`);
      }
    },
  };
  const formatDigit = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        thousand: ",",
      });
    }
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 30,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 30,
        hide: true,
        pivot: false,
        resizable: true,
      },
      {
        headerName: "HIERARCHY",

        children: [
          {
            headerName: "UNIQUE ID",
            field: "uniqueId",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "FIELD",
            field: "field",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "WELL",
            field: "well",
            sortable: true,
            resizable: true,
            filter: true,
            width: 100,
          },
          {
            headerName: "LEVEL",
            field: "level",
            filter: true,
            sortable: true,
            resizable: true,
            width: 80,
          },
        ],
      },
      {
        headerName: 'CHOKE (1/64)"',
        field: "choke",
        filter: true,
        width: 80,
        sortable: true,
        resizable: true,
      },
      {
        headerName: "DAYS",
        field: "days",
        sortable: true,
        resizable: true,
        width: 80,
      },
      {
        headerName: "MONTH PROD.",
        field: "numMonthProduced",
        sortable: true,
        resizable: true,
        width: 120,
      },
      {
        headerName: "DATE LAST PROD.",
        field: "dateLastProduced",
        sortable: true,
        resizable: true,
        width: 120,
        cellRenderer: function (props) {
          if (
            _.isEmpty(props.data.dateLastProduced) ||
            _.isNull(props.data.dateLastProduced) ||
            _.isUndefined(props.data.dateLastProduced)
          ) {
            return "";
          }
          return moment(props.data.dateLastProduced).format("D-MMM-YY");
        },
      },

      {
        headerName: "MONTHLY PRODUCTION",

        children: [
          {
            headerName: "OIL (stb)",
            field: "oil",
            cellStyle: { textAlign: "center", backgroundColor: "#ffcdd2" },

            width: 100,
            sortable: true,
            resizable: true,

            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "GAS (Mscf)",
            field: "gas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#C8E6C9",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "WATER (stb)",

            field: "water",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#FFECB3",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "Oil Cummulative (stb)",

            field: "cumOil",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "Gas Cummulative (Mscf)",

            field: "cumGas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: " Cummulative Water Prod (stb)",

            field: "cumWater",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
        ],
      },
      {
        headerName: "TYPE",
        field: "type",
        sortable: true,
        resizable: true,

        width: 80,
      },
      {
        headerName: "REMARKS",
        field: "remarks",
        sortable: true,
        resizable: true,

        width: 150,
      },
    ],
  };

  return (
    <Layout style={{ background: "#fff", marginTop: "5px" }}>
      <Content style={{ background: "#fff" }}>
        <Layout>
          <Sider
            width={320}
            style={{ background: "#F0F2F5", height: "100vh", padding: "10px" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <SubPageHeaderTitle title="Browse Pane" />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <Form layout="vertical">
                    <Form.Item
                      label={
                        <span style={{ color: "red" }}>
                          Production Refer Month *
                        </span>
                      }
                    >
                      <Tooltip title="NAOC JV operations STRING production month">
                        <DatePicker
                          picker="month"
                          value={toAntPickerDate(monthlyPerformanceStore?.uploadDate)}
                          onChange={(date, dateSTRING) => {
                            if (date) {
                              monthlyPerformanceStore.uploadDate = getPickerDate(date);

                              console.log(monthlyPerformanceStore.uploadDate);
                            }
                          }}
                          style={{ width: "100%" }}
                          defaultValue={toAntPickerDate(new Date())}
                          format={"MMMM YYYY"}
                        />
                      </Tooltip>
                    </Form.Item>

                    <Form.Item
                      label={
                        <span style={{ color: "red" }}>
                          Input Deck WorkSheet *
                        </span>
                      }
                    >
                      <Tooltip title="enter the sheetname where the STRING production is located in the browsed workbook ">
                        <Input
                          placeholder="Worksheet Name"
                          value={monthlyPerformanceStore.sheetName}
                          onChange={({ target }) => {
                            monthlyPerformanceStore.sheetName = target.value;
                          }}
                        />
                      </Tooltip>
                    </Form.Item>
                    <Form.Item>
                      <Dragger
                        style={{
                          width: "100%",
                          backgroundColor: "transparent",
                        }}
                        multiple={false}
                        {...uploadprops}
                      >
                        <p className="ant-upload-drag-icon">
                          <FileExcelOutlined style={{ color: "#68D391" }} />
                        </p>
                        <p className="ant-upload-text">
                          Browse for STRING Production Input Deck
                        </p>
                      </Dragger>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </Sider>
          <Content style={{ background: "#F0F2F5", paddingLeft: "10px" }}>
            <div
              className="ms-Grid"
              dir="ltr"
              style={{ background: "white", paddingLeft: "10px" }}
            >
              <Pivot
                linkSize={PivotLinkSize.normal}
                selectedKey={monthlyPerformanceStore.selTab}
                onLinkClick={(item, ev) => {
                  monthlyPerformanceStore.selTab = item.props.itemKey;
                }}
              >
                <PivotItem
                  headerText="STRING Production Import"
                  itemKey="1"
                  onRenderItemLink={(link, defaultRenderer) => (
                    <span>
                      {defaultRenderer(link)}{" "}
                      <Badge
                        count={
                          monthlyPerformanceStore.monthlyProductions.length
                        }
                        overflowCount={1000}
                      />
                    </span>
                  )}
                >
                  <div className="ms-Grid-row" style={{ background: "white" }}>
                    <CommandBar
                      items={[
                        {
                          key: "clear",
                          text: "Clear Data",
                          onRenderIcon: () => <X />,
                          onClick: () => {
                            monthlyPerformanceStore.monthlyProductions = [];
                          },
                        },
                      ]}
                      farItems={[
                        {
                          key: "search",
                          onRender: () => (
                            <Tooltip title="smart quick search on the production data displayed">
                              <SearchBox
                                placeholder="Search"
                                styles={{
                                  root: {
                                    width: "100%",
                                    borderBottomColor: "#CBD5E0",
                                  },
                                }}
                                underlined={true}
                                onChange={(ev, searchTerms) => {
                                  prodImportGrid.current.api.setQuickFilter(
                                    searchTerms
                                  );
                                  // const filterValue = grid.current.api.filterManager.quickFilter;
                                }}
                              ></SearchBox>
                            </Tooltip>
                          ),
                        },
                        {
                          key: "spacere",
                          onRender: () => <div style={{ width: "100px" }} />,
                        },
                        {
                          key: "n",
                          onRender: () => (
                            <div style={{ textAlign: "center" }}>
                              <Tooltip title="click to download standard monthly production input deck.">
                                <Link
                                  underline={true}
                                  style={{ textDecoration: "underline" }}
                                  onClick={async () => {
                                    try {
                                      await monthlyPerformanceStore.downlaodMonthlyProductionTemplate();
                                    } catch (error) {
                                      notification.error({
                                        message: "SPARS Feedback",
                                        description: error.message,
                                      });
                                    }
                                  }}
                                >
                                  Download standard monthly production input
                                  deck
                                </Link>
                              </Tooltip>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                  {monthlyPerformanceStore.isDownloadingTemplate && (
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        <ProgressIndicator
                          description="downloading template,please wait..."
                          styles={{ root: { textAlign: "center" } }}
                        ></ProgressIndicator>
                      </div>
                    </div>
                  )}
                  <div
                    className="ag-theme-balham qikreach-grid-fill"
                    style={{
                      minHeight: "50vh",
                      height: "100vh",
                      width: "100%",
                      maxHeight: "80vh",
                    }}
                  >
                    <AgGridReact
                      rowData={[
                        ...monthlyPerformanceStore.monthlyProductions.values(),
                      ]}
                      sideBar={["filters"]}
                      ref={prodImportGrid}
                      gridOptions={{
                        defaultColDef: {
                          sortable: true,
                          filter: true,
                          enableValue: true,
                          enableRowGroup: true,
                        },
                        enableCharts: true,
                        enableRangeSelection: true,

                        rowSelection: "single",
                        pagination: true,
                        columnDefs: gridcolumnDefs.columnDefs,
                        animateRows: true,
                        statusBar: {
                          statusPanels: [
                            {
                              statusPanel: "agTotalRowCountComponent",
                              align: "center",
                            },
                          ],
                        },
                        columnTypes: {
                          numberColumn: {
                            width: 130,
                            filter: "agNumberColumnFilter",
                          },
                          medalColumn: {
                            width: 100,
                            columnGroupShow: "open",
                            filter: false,
                          },
                          nonEditableColumn: { editable: false },
                          dateColumn: {
                            filter: "agDateColumnFilter",
                            filterParams: {
                              comparator: function (
                                filterLocalDateAtMidnight,
                                cellValue
                              ) {
                                var dateParts = cellValue.split("/");
                                var day = Number(dateParts[0]);
                                var month = Number(dateParts[1]) - 1;
                                var year = Number(dateParts[2]);
                                var cellDate = new Date(year, month, day);
                                if (cellDate < filterLocalDateAtMidnight) {
                                  return -1;
                                } else if (
                                  cellDate > filterLocalDateAtMidnight
                                ) {
                                  return 1;
                                } else {
                                  return 0;
                                }
                              },
                            },
                          },
                        },
                      }}
                      rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
                      copyHeadersToClipboard={true}
                      overlayLoadingTemplate={`${(
                        <span class="ag-overlay-loading-center">
                          Please wait while your rows are loading
                        </span>
                      )}`}
                      overlayNoRowsTemplate={
                        '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result,Proceed to Import</span>'
                      }
                    ></AgGridReact>
                  </div>
                </PivotItem>
                <PivotItem
                  headerText="Deck Upload Data Validation"
                  itemKey="2"
                  onRenderItemLink={(link, defaultRenderer) => (
                    <span>
                      <InfoCircleOutlined style={{ color: "red" }} />{" "}
                      {defaultRenderer(link)}{" "}
                      <Badge
                        count={monthlyPerformanceStore.uploadErrors.length}
                      />
                    </span>
                  )}
                >
                  <ErrorLogs />
                </PivotItem>
              </Pivot>
            </div>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
});

